<template>
  <div class="container">
    <h1>Configure Automations</h1>
    <b-tabs position="is-centered" class="block" v-model="activeTab">
      <b-tab-item label="List">
        <div class="level" style="margin-top: 1rem;">
          <div class="level-left">
            <div class="level-item">
              <b-switch
                  v-model="advancedView"
                  true-value="1"
                  false-value="0"
                  @input="handleChangeView"
              >
                {{displayedAdvancedView}}
              </b-switch>
            </div>
          </div>
        </div>
        <app-automation-list/>
      </b-tab-item>
      <b-tab-item label="Create Automation">
        <app-create-automation/>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import BTabItem from "buefy/src/components/tabs/TabItem";
  import CreateAutomation from "../components/configure/CreateAutomation";
  import AutomationList from "../components/configure/AutomationList";
  import BSwitch from "buefy/src/components/switch/Switch";

  export default {
    name: "screenconfigureautomations",
    components: {
      BSwitch,
      BTabItem,
      appCreateAutomation: CreateAutomation,
      appAutomationList: AutomationList
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        definition: '',
        advancedView: 0
      };
    },
    computed: {
      ...mapGetters('ui', ['automationsAdvancedView']),
      displayedAdvancedView() {
        return parseInt(this.advancedView, 10) === 1 ? 'Advanced' : 'Simple';
      }
    },
    methods: {
      ...mapActions('triggers', ['createTrigger']),
      ...mapMutations('ui', ['SET_AUTOMATIONS_ADVANCED_VIEW', 'SET_AUTOMATIONS_ADVANCED_VIEW_CHANGED']),
      validFields() {
        return this.name.length > 1 && this.definition.length > 2;
      },
      handleCancel() {
        this.resetFields();
        this.activeTab = 0;
      },
      handleCreate() {
        this.createTrigger({
          name: this.name,
          definition: this.definition
        });
        this.handleCancel();
      },
      handleChangeView() {
        const valueToSet = parseInt(this.advancedView, 10) === 1;
        this['SET_AUTOMATIONS_ADVANCED_VIEW'](valueToSet);
        this['SET_AUTOMATIONS_ADVANCED_VIEW_CHANGED']();
      },
      resetFields() {
        this.name = '';
        this.definition = '';
      }
    },
    mounted() {
      this.advancedView = this.automationsAdvancedView ? 1 : 0;
    }
  }
</script>

<style scoped>
  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .container {
    margin-top: 1rem;
  }
</style>